import {
  FixedAssetReturnStateTypes,
  FixedAssetReturnActionTypes,
} from "./FixedAssetReturn.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FixedAssetReturnStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchReport: resetApiCallState([]),
};

const FixedAssetReturnReducer = (
  state: FixedAssetReturnStateTypes = INITIAL_STATE,
  action: any
): FixedAssetReturnStateTypes => {
  switch (action.type) {
    case FixedAssetReturnActionTypes.FETCH_ALL_FIXED_ASSET_RETURN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetReturnActionTypes.FETCH_ALL_FIXED_ASSET_RETURN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FixedAssetReturnActionTypes.FETCH_ALL_FIXED_ASSET_RETURN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetReturnActionTypes.FETCH_ALL_FIXED_ASSET_RETURN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FixedAssetReturnActionTypes.FETCH_REPORT_FIXED_ASSET_RETURN:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetReturnActionTypes.FETCH_REPORT_FIXED_ASSET_RETURN_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState([]),
      };
    case FixedAssetReturnActionTypes.FETCH_REPORT_FIXED_ASSET_RETURN_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetReturnActionTypes.FETCH_REPORT_FIXED_ASSET_RETURN_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FixedAssetReturnReducer;
